import { formatVal } from '../../../../helpers/value'
import { EMPTY_VALUE } from '../../../../utils/common'
import { DISPLAY_TYPES } from '../../constants'
import TotalCompany from './TotalCompany'

export const handleHightLightData = (
  displayType,
  totalCompanyData,
  hightLight,
  scrollClass,
  scrollActiveRow,
  showListCompany,
  locale,
) => {
  if (!Array.isArray(hightLight) || !hightLight.length) return []

  const firstItem = getFirstItem(displayType, totalCompanyData, showListCompany)
  const otherItem = hightLight.map((item, index, arr) => {
    const [values] = item.values
    const { rowId, keyTypePrefix, scrollPosition } = scrollClass[index]
    return {
      title: item.ratioName,
      detail: handleDetail(values?.median, item.unit, locale),
      isShowSeparator: index !== arr.length - 1,
      scrollElementClass: scrollPosition,
      otherBehavior: scrollActiveRow({ rowId, keyTypePrefix }),
    }
  })
  return [firstItem, ...otherItem]
}

const getFirstItem = (
  displayType,
  { totalCompany, totalCount },
  showListCompany,
) => {
  const firstItemTitle = Object.keys(DISPLAY_TYPES).find(
    (key) => DISPLAY_TYPES[key] === displayType,
  )

  return {
    title: `portfolio.finance.${firstItemTitle}`,
    formatDetail: () => (
      <TotalCompany totalCompany={totalCompany} totalCount={totalCount} />
    ),
    isShowSeparator: true,
    isI18n: true,
    onDetailClick: showListCompany,
  }
}

export const formatInteger = (val, locale) => formatVal(val, locale, false, 0)

const handleDetail = (value, unit, locale) => {
  if (typeof value !== 'number') {
    return EMPTY_VALUE
  }

  if (unit === '%') {
    return `${formatVal(value * 100, locale)}${unit}`
  }

  return `${formatInteger(value, locale)} ${unit}`
}
